import { render } from "./EmployeeSearch.vue?vue&type=template&id=2c057a7c"
import script from "./EmployeeSearch.vue?vue&type=script&lang=js"
export * from "./EmployeeSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__